import React from 'react';
import PropTypes from 'prop-types';
import styles from './Input.module.scss';

const Input = props => {
    return (
        <div className={styles.inputGroup} style={{ marginTop: props.marginTop }}>
            <input
                className={styles.input}
                type={props.inputType ? props.inputType : 'text'}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
            />
            <span
                className={`icon-keyboard ${styles.keyboardBtn}`}
                onClick={() => props.showVirtualKeyboard()}
            />
        </div>
    );
};

Input.propTypes = {
    placeholder: PropTypes.string.isRequired,
};

export default Input;
